import React from 'react';
import { Box } from '@99designs/ui';
import { Wordmark } from '@99designs/purgatory';
import SiteFooter from '@99designs/frontend-components/apps/global-nav/components/SiteFooter/SiteFooter';
import { useSite } from '@99designs/apps/spa/common/SiteContext';

function PageLayout({ children }: { children: React.ReactNode }) {
    const site = useSite();

    return (
        <Box as="main" display="flex" flexDirection="column" flexGrow={1}>
            <Box
                display="flex"
                justifyContent="center"
                padding={['halfGutter', 'gutter']}
                flexGrow={1}
            >
                <Box flexGrow={1} maxWidth="400px">
                    <Box display="flex" justifyContent="center" paddingBottom="gutter">
                        <a href="/" title={__('99designs by Vistaprint')}>
                            <Wordmark />
                        </a>
                    </Box>
                    {children}
                </Box>
            </Box>
            <Box marginTop="space10" width="100%">
                <SiteFooter isFocused site={site} />
            </Box>
        </Box>
    );
}

export default PageLayout;
